import { render, staticRenderFns } from "./IconElementText.vue?vue&type=template&id=5bbdccf3&"
import script from "./IconElementText.vue?vue&type=script&lang=js&"
export * from "./IconElementText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5bbdccf3')) {
      api.createRecord('5bbdccf3', component.options)
    } else {
      api.reload('5bbdccf3', component.options)
    }
    module.hot.accept("./IconElementText.vue?vue&type=template&id=5bbdccf3&", function () {
      api.rerender('5bbdccf3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconElementText.vue"
export default component.exports